import { jsx } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
export function RuiBadge({
  children,
  variant = "filled",
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("span", {
    ...props,
    class: cx("rui-badge", `rui-badge--${variant}`, className),
    children
  });
}